import TextArea from '@/components/Form/TextArea.jsx'

import {
    PropertiesController,
    usePropertiesController,
} from './PropertiesController.jsx'

const defaultAutoSize = {minRows: 3}

export default function PropertiesControllerLongText({
    className,
    style,
    disabled,
    hidden,
    label,
    labelSuffix,
    prop,
    required,
    readOnly,
    value,
    ...props
}) {
    const p = usePropertiesController({
        disabled,
        hidden,
        label,
        prop,
        readOnly,
        required,
        value,
    })

    return (
        <PropertiesController
            className={className}
            style={style}
            error={p.error}
            hidden={p.hidden}
            label={p.label}
            labelSuffix={labelSuffix}
            required={p.required}
        >
            <TextArea
                allowClear
                autoSize={defaultAutoSize}
                disabled={p.disabled}
                readOnly={p.readOnly}
                value={p.value}
                onBlur={p.onBlur}
                onChange={p.onChange}
                onFocus={p.onFocus}
                {...props}
            />
        </PropertiesController>
    )
}
